<div class="spinner-inner noselect">
    <img
        src="./assets/unity-1.2.0/images/icon-spinner.svg"
        alt="Loading"
        draggable="false"
    />
</div>